import { useMemo } from "react";
import { Link } from "react-router-dom";
import { capitalize } from "@datassential/platform-ui-lib";
import { CategoryProfileRelatedProfile } from "@apiHooks/useCategoryProfileDetails";
import { getRandomItems } from "@helpers";
import { routeNames } from "@core/routeNames";
import ProfileSidebarSection from "@components/ProfileSidebarSection/ProfileSidebarSection";
import "./RelatedProfiles.styles.scss";

interface Props {
    profiles: CategoryProfileRelatedProfile[];
}

const RelatedProfiles = ({ profiles }: Props) => {
    const items = useMemo(() => getRandomItems(profiles, 5), [profiles]);

    if (items.length === 0) return null;

    return (
        <ProfileSidebarSection className="RelatedProfiles" title="RELATED PROFILES">
            <div className="RelatedProfiles__chips">
                {items.map(({ wordId, wordName }) => (
                    <Link
                        key={wordId}
                        className="RelatedProfiles__chip"
                        to={{
                            pathname: routeNames.food,
                            search: `?q=${encodeURIComponent(wordName)}`,
                        }}
                    >
                        {capitalize(wordName)}
                    </Link>
                ))}
            </div>
        </ProfileSidebarSection>
    );
};

export default RelatedProfiles;
